<div class="container-fluid main-card">
    <ng-template #subscriptionSummary>
        <ng-container *ngIf="user.subscription.subscription_id != ''">
            Abonnement <b>{{ durationLabels[user.subscription.duration] || user.subscription.duration }}</b><ng-container *ngIf="user.subscription.current_period_end != '' && (user.subscription.cancel_date == '01/01/0001' || user.subscription.cancel_date == '01/01/1970')"> (Renouvellement le {{ user.subscription.current_period_end | date:'dd/MM/yyyy' }})</ng-container>
        </ng-container>
    </ng-template>
    <div class="row">
        <div class="col-md-8 col-12">
            <h1>
                Gérer mon abonnement
                <span>Accès à votre abonnement et votre moyen de paiement</span>
            </h1>
        </div>

        <div class="col-xxl-6 offset-xxl-3 col-12 offset-0">
            <div class="message shadow-lg p-3 bg-white"
                 *ngIf="success == '' && error == '' && promo == 'bf'">
                L'offre Black Friday expire dans :<br/>
                <p class="fs-6 mb-0">
                    <img src="https://img1.niftyimages.com/eulh/8--7/vqnp" class="img-fluid"
                         style="display: block;margin: 0 auto;"/><br/>
                </p>
                <p class="fs-7 mb-0" style="line-height: 16px;">
                    <b>Informations : 40% de réduction sur l'abonnement de votre choix pendant 3 mois, ou bien pendant 1
                        an pour les abonnements annuels. Hors abonnements professionnels.</b><br/>
                    <br/>
                    Valable pour tout nouvel abonnement et pour les clients actuels dans le cas d'une souscription à un
                    forfait supérieur, ou bien le passage sur une fréquence annuelle.
                </p>
            </div>

            <div class="bloc-info bloc-promo row"
                 *ngIf="success == '' && error == '' && promo == 'rentree'">
                <!-- Icône hors flux : le titre se centre alors sur toute la largeur,
                     donc sur le même axe que le compteur -->
                <div class="col-12 mb-2 position-relative">
                    <div class="icon-wrap position-absolute top-0 start-0 ms-2">
                        <i class="icon icon-clock bg-primary"></i>
                    </div>
                    <div class="fs-2 text-center" style="line-height: 40px;">
                        L'offre de rentrée <b>expire dans :</b>
                    </div>
                </div>
                <div class="col-12">
                    <app-promo-countdown></app-promo-countdown>
                    <p class="fs-4 text-center mt-3 mb-0">
                        -30% pendant 1 an pour tous les abonnements annuels ou -30% sur les
                        3 premiers mois pour les abonnements mensuels et trimestriels.
                    </p>
                </div>
            </div>
        </div>

        <div class="col-lg-12">
            <div class="row">
                <div class="col-md-6">
                    <div class="bloc-info row"
                         *ngIf="(user.plan == 'trial' || user.plan == 'trial_plus') && user.pro_plan == ''">
                        <div class="col-12 mb-4">
                            <div class="icon-wrap">
                                <i class="icon icon-house bg-primary"></i>
                            </div>
                            <div class="fs-2" *ngIf="user.plan == 'trial'">
                                Forfait <b>Période d'essai</b>
                                <span class="fs-4">Expire dans <b>{{ authenticationService.getTrialDay() | number:'1.0-0' }}
                                    jours</b><ng-container *ngIf="user.subscription.subscription_id != ''"> | </ng-container><ng-container *ngTemplateOutlet="subscriptionSummary"></ng-container></span>
                            </div>
                            <div class="fs-2" *ngIf="user.plan == 'trial_plus'">
                                Forfait <b>Période d'essai essentiel</b>
                                <span class="fs-4">Expire dans <b>{{ authenticationService.getTrialPlusDay() | number:'1.0-0' }}
                                    jours</b><ng-container *ngIf="user.subscription.subscription_id != ''"> | </ng-container><ng-container *ngTemplateOutlet="subscriptionSummary"></ng-container></span>
                            </div>
                        </div>
                        <div class="col-md-6 col-12 fs-3 offers">
                            <ng-container *ngIf="promo == 'parrain'">
                                <b>Un mois offert</b>
                                <span class="fs-4">Grâce à votre parrain, profitez en !</span>
                            </ng-container>

                            <ng-container *ngIf="promo == 'partner'">
                                Grâce à {{ partner?.name }}, profitez de
                                -{{ partner?.discount }}%
                                <span
                                    class="fs-4 duration">{{ partner?.duration }}</span>
                            </ng-container>

                            <ng-container *ngIf="promo == 'partner_1month'">
                                <b>Un mois offert</b>
                                <span
                                    class="fs-4">Vous profitez d'1 mois offert sur tous les abonnements LyBox grâce à {{ partner?.name }}
                                    , profitez en !</span>
                            </ng-container>
                        </div>
                        <div class="col-md-6 col-12">
                            <a *ngIf="user.subscription.status == ''" href="/app/user/plan#plan"
                               class="btn btn-lg d-block">Choisir un forfait</a>
                        </div>
                    </div>

                    <div class="bloc-info row"
                         *ngIf="user.subscription.status == 'past_due'">
                        <div class="col-12 mb-4">
                            <div class="icon-wrap">
                                <i class="icon icon-house bg-primary"></i>
                            </div>
                            <div class="fs-2">
                                Forfait <b>{{ user.subscription.plan | titlecase }}</b>
                                <span class="fs-4 text-red">
                                     Le renouvellement de votre abonnement a échoué et vos accès ont été désactivés
                                 </span>
                            </div>
                        </div>
                        <div class="col-md-3 col-12">
                            <a *ngIf="user.subscription.cancel_date == '01/01/0001' || user.subscription.cancel_date == '01/01/1970'"
                               (click)="openChurn()"
                               class="btn btn-ghost btn-lg d-block">Résilier</a>
                        </div>
                        <div class="col-md-3 col-12">
                            <a href="mailto:contact@lybox.fr?subject=Erreur de paiement"
                               class="btn btn-lg btn-outline d-block">Contactez-nous</a>
                        </div>
                        <div class="col-md-6 col-12">
                            <a (click)="retryPayment(1)" *ngIf="user.payment_method.type != ''"
                               class="btn btn-lg btn-danger float-right d-block">
                                <mat-spinner diameter="25" [hidden]="!loading_retry"></mat-spinner>
                                <ng-container *ngIf="loading_retry == false">Réessayer le paiement</ng-container>
                            </a>
                        </div>
                    </div>

                    <div class="bloc-info row"
                         *ngIf="user.plan != '' && user.plan != 'trial' && user.plan != 'trial_plus' && user.pro_plan == ''">
                        <div class="col-12 mb-4">
                            <div class="icon-wrap">
                                <i class="icon icon-house bg-primary"></i>
                            </div>
                            <div class="fs-2">
                                Forfait <b>{{ user.plan == 'partner' ? 'Partenaire' : (user.plan | titlecase) }}</b>
                                <span class="fs-4">
                                    <ng-container *ngIf="user.subscription.cancel_date != '01/01/0001' && user.subscription.cancel_date != '01/01/1970'">
                                        Votre abonnement sera résilié le {{ user.subscription.cancel_date }} |
                                    </ng-container>
                                    <ng-container *ngTemplateOutlet="subscriptionSummary"></ng-container>
                                </span>
                            </div>
                        </div>
                        <div class="col-md-6 col-12">
                            <a *ngIf="user.plan != 'partner' && (user.subscription.cancel_date == '01/01/0001' || user.subscription.cancel_date == '01/01/1970')"
                               (click)="openChurn()"
                               class="btn btn-ghost btn-lg d-block">Résilier</a>
                        </div>
                        <div class="col-md-6 col-12">
                            <a href="/app/user/plan#plan"
                               class="btn btn-lg d-block">Changer mon forfait</a>
                        </div>
                    </div>

                    <div class="bloc-info row"
                         *ngIf="user.subscription.plan == '' && user.plan == '' && user.pro_plan == ''">
                        <div class="col-12 mb-4">
                            <div class="icon-wrap">
                                <i class="icon icon-house bg-primary"></i>
                            </div>
                            <div class="fs-2 center-title">
                                Aucun forfait en cours
                            </div>
                        </div>
                        <div class="col-md-6 col-12 fs-2 offers">
                            <ng-container *ngIf="promo == 'parrain'">
                                <b>Un mois offert</b>
                                <span class="fs-4">Grâce à votre parrain, profitez en !</span>
                            </ng-container>

                            <ng-container *ngIf="promo == 'partner'">
                                Grâce à {{ partner?.name }}, profitez de
                                -{{ partner?.discount }}%
                                <span
                                    class="fs-4 duration">{{ partner?.duration }}</span>
                            </ng-container>

                            <ng-container *ngIf="promo == 'partner_1month'">
                                <b>Un mois offert</b>
                                <span
                                    class="fs-4">Vous profitez d'1 mois offert sur tous les abonnements LyBox grâce à {{ partner?.name }}
                                    , profitez en !</span>
                            </ng-container>
                        </div>
                        <div class="col-md-6 col-12">
                            <a href="/app/user/plan#plan"
                               class="btn btn-lg d-block">Choisir mon forfait</a>
                        </div>
                    </div>

                    <div class="bloc-info row"
                         *ngIf="user.pro_plan != ''">
                        <div class="col-12">
                            <div class="icon-wrap">
                                <i class="icon icon-house bg-primary"></i>
                            </div>
                            <div class="fs-2">
                                Forfait <b>Professionnel</b>
                            </div>
                        </div>
                    </div>

                </div>
                <div class="col-md-6">
                    <div class="bloc-info row">
                        <div class="col-12 mb-4">
                            <div class="icon-wrap">
                                <i class="icon icon-card bg-primary"></i>
                            </div>
                            <div class="fs-2 center-title">
                                Moyen de paiement
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="infoCb">
                                <a (click)="updateCB()" *ngIf="user.payment_method.type != ''"
                                   class="btn btn-lg btn-outline float-right">
                                    <mat-spinner diameter="25" [hidden]="!loading_pm"></mat-spinner>
                                    <ng-container *ngIf="loading_pm == false">Modifier</ng-container>
                                </a>

                                <b class="fs-4" *ngIf="user.payment_method.type == ''">
                                    Aucun moyen de paiement enregistré<br/><br/>
                                </b>

                                <b class="fs-4" *ngIf="user.payment_method.type == 'sepa_debit'">
                                    Prélèvement bancaire<br/>
                                </b>
                                <b class="fs-4" *ngIf="user.payment_method.type == 'card'">
                                    {{ user.payment_method.type_detail | titlecase }} **** **** **** {{ user.payment_method.last_4 }}
                                    <br/>
                                    Expire en {{ user.payment_method.exp_month }}/{{ user.payment_method.exp_year }}
                                </b>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="row d-flex justify-content-around align-items-stretch pricing mt-5">

        <div class="text-center mb-3 col-12">
            <div id="plan" class="duration_choose mb-3">
                <div class="duration {{ duration == 'month' ? 'active' : ''}}" (click)="setDuration('month')">
                    Mensuel
                </div>
                <div class="duration {{ duration == 'quarter' ? 'active' : ''}}" (click)="setDuration('quarter')">
                    Trimestriel
                    <div class="discount">
                        -10%
                    </div>
                </div>
                <div class="duration {{ duration == 'year' ? 'active' : ''}}" (click)="setDuration('year')">
                    Annuel
                    <div class="discount">
                        -20%
                    </div>
                </div>
            </div>
            <b>
                Sans engagement - Résiliable à tout moment
            </b>
        </div>

        <div class="col-12 position-relative" [ngClass]="{'promo-padding': promo}">
            <div class="row justify-content-center">
                <div class="col-basique">
                    <div class="pricing-light">
                        <h2 class="basique pb-3">Basique</h2>
                        <p class="desc">Pour les investisseurs débutants qui veulent <b>se rassurer avant de se lancer.</b></p>
                        <b class="price">
                            <s class="promo"
                               *ngIf="promo == 'bf' || promo == 'rentree' || promo == 'partner' || promo == 'onboarding'">
                                ({{ userService.getPrice("basique", duration, user, promo, partner?.discount || 0)[1] | number:'1.0-2' }} €)
                            </s>
                            <img *ngIf="promo == 'bf'" src="assets/promo-bf-40.png"/>
                            <img *ngIf="promo == 'rentree'" src="assets/promo-rentree.png"/>
                            {{ userService.getPrice("basique", duration, user, promo, partner?.discount || 0)[0]|number:'1.0-2' }} €<span class="fs-5">/mois</span>
                            <small
                                *ngIf="(promo == 'bf' || promo == 'rentree') && (duration == 'month' || duration == 'quarter')">Pendant
                                3 mois</small>
                        </b>
                        <ng-container *ngIf="promo == 'partner_1month' || promo == 'parrain'">
                            Votre premier mois est offert
                        </ng-container>
                        <span class="diff_annuel" *ngIf="userService.getPrice('basique', duration, user, promo, partner?.discount || 0)[2] > 0">
                            ÉCONOMISEZ {{ userService.getPrice('basique', duration, user, promo, partner?.discount || 0)[2] }}€/AN EN PAYANT À L'ANNÉE
                        </span>

                        <a class="btn btn-outline-primary"
                           *ngIf="(user.plan == '' || user.plan == 'trial' || user.plan == 'trial_plus') && user.pro_plan == '' && user.subscription.plan == ''"
                           (click)="planSelect('basique')">
                            <mat-spinner diameter="25" [hidden]="!loading"></mat-spinner>
                            <span [hidden]="loading">Choisir ce forfait</span>
                        </a>
                        <ng-container *ngIf="user.plan != '' && user.plan != 'trial' && user.plan != 'trial_plus' && user.pro_plan == ''">
                            <a class="btn btn-outline-primary"
                               *ngIf="user.subscription.plan != 'basique'"
                               (click)="planChange('basique')">
                                Modifier mon forfait
                            </a>
                            <div class="text-center" *ngIf="user.subscription.plan == 'basique'">
                                <p class="btn btn-disabled">
                                    <i class="fa fa-check"></i> Forfait actuel
                                </p>
                                <a (click)="planChange('basique')" class="cursor-pointer d-block mb-1">Modifier la fréquence</a>
                            </div>
                        </ng-container>

                        <h4>Fonctionnalités :</h4>
                        <ul class="pricing-features">
                            <li>
                                Extension navigateur
                                <i class="fa fa-question-circle ms-2" matTooltipClass="tooltip-button"
                                   matTooltip="Extension disponible sur Google Chrome et Mozilla Firefox. Compatible avec Leboncoin, SeLoger, Logic Immo et AvendreAlouer"></i>
                            </li>
                            <li>Accès à la communauté WhatsApp et aux Webinaires</li>
                            <li>Analyse du marché immobilier</li>
                            <li>
                                Calcul de rendement et de CF
                                <i class="fa fa-question-circle  ms-2" matTooltipClass="tooltip-button"
                                   matTooltip="Simulateur d’investissement locatif : Calculez simplement et rapidement le rendement, le cash-flow et la fiscalité de votre investissement locatif sur les 30 prochaines années"></i>
                            </li>
                            <li>Simulation en Foncier et LMNP
                                <i class="fa fa-question-circle ms-2"
                                   matTooltipClass="tooltip-button"
                                   matTooltip="Foncier forfait, foncier réel, LMNP forfait, LMNP réel"></i>
                            </li>
                            <li>5 analyses IA par mois
                                <i class="fa fa-question-circle ms-2" matTooltipClass="tooltip-button"
                                   [matTooltip]="aiCreditTooltip"></i>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="col-essentiel">
                    <div class="p-4 pt-3 pb-3 populaire bg-primary text-white">
                        POPULAIRE
                        <img src="https://www.lybox.fr/build/images/flag_pop.png.webp" alt="Populaire"/>
                    </div>
                    <div class="pricing-light active">
                        <h2 class="essentiel pb-3">Essentiel</h2>
                        <p class="desc">
                            Pour les investisseurs <b>en recherche active</b> qui souhaitent trouver des biens rentables.
                        </p>
                        <b class="price">
                            <s class="promo"
                               *ngIf="promo == 'bf' || promo == 'rentree' || promo == 'partner' || promo == 'onboarding'">
                                ({{ userService.getPrice("essentiel", duration, user, promo, partner?.discount || 0)[1] | number:'1.0-2' }} €)
                            </s>
                            <img *ngIf="promo == 'bf'" src="assets/promo-bf-40.png"/>
                            <img *ngIf="promo == 'rentree'" src="assets/promo-rentree.png"/>
                            {{ userService.getPrice("essentiel", duration, user, promo, partner?.discount || 0)[0]|number:'1.0-2' }} €<span class="fs-5">/mois</span>
                            <small
                                *ngIf="(promo == 'bf' || promo == 'rentree') && (duration == 'month' || duration == 'quarter')">Pendant
                                3 mois</small>
                        </b>
                        <ng-container *ngIf="promo == 'partner_1month' || promo == 'parrain'">
                            Votre premier mois est offert
                        </ng-container>
                        <span class="diff_annuel" *ngIf="userService.getPrice('essentiel', duration, user, promo, partner?.discount || 0)[2] > 0">
                            ÉCONOMISEZ {{ userService.getPrice('essentiel', duration, user, promo, partner?.discount || 0)[2] }}€/AN EN PAYANT À L'ANNÉE
                        </span>

                        <a class="btn btn-primary"
                           *ngIf="(user.plan == '' || user.plan == 'trial' || user.plan == 'trial_plus') && user.pro_plan == '' && user.subscription.plan == ''"
                           (click)="planSelect('essentiel')">
                            <mat-spinner diameter="25" [hidden]="!loading"></mat-spinner>
                            <span [hidden]="loading">Choisir ce forfait</span>
                        </a>
                        <ng-container *ngIf="user.plan != '' && user.plan != 'trial' && user.plan != 'trial_plus' && user.pro_plan == ''">
                            <a *ngIf="user.subscription.plan != 'essentiel'"
                               class="btn btn-primary"
                               (click)="planChange('essentiel')">
                                Modifier mon forfait
                            </a>
                            <div class="text-center" *ngIf="user.subscription.plan == 'essentiel'">
                                <p class="btn btn-disabled">
                                    <i class="fa fa-check"></i> Forfait actuel
                                </p>
                                <a (click)="planChange('essentiel')" class="cursor-pointer d-block mb-1">Modifier la fréquence</a>
                            </div>
                        </ng-container>
                        <h4>Fonctionnalités dans Basique, et : </h4>
                        <ul class="pricing-features">
                            <li>
                                Moteur de recherche spécial investisseur (1500 sites réunis)
                                <i class="fa fa-question-circle  ms-2" matTooltipClass="tooltip-button"
                                   matTooltip="Moteur de recherche immobilier : Retrouvez toutes les annonces immobilières du web au même endroit. Faites des recherches précises en se basant sur plus de 30 critères conçus pour les investisseurs"></i>
                            </li>
                            <li>Filtres de recherche avancés</li>
                            <li>
                                Alertes mails en direct
                                <i class="fa fa-question-circle  ms-2" matTooltipClass="tooltip-button"
                                   matTooltip="Alertes mails en direct : Soyez avertis automatiquement lorsqu’une nouvelle annonce qui correspond à vos critères est publiée sur n’importe quel site immobilier"></i>
                            </li>
                            <li>
                                Trouver les villes rentables
                                <i class="fa fa-question-circle  ms-2" matTooltipClass="tooltip-button"
                                   matTooltip="Trouver les villes rentables : Un module de recherche vous permet de trouver les villes à potentiel dans votre département ou autour de chez vous, en fonction de vos objectifs d’investissement"></i>
                            </li>
                            <li>Imposition à la revente
                                <i class="fa fa-question-circle ms-2"
                                   matTooltipClass="tooltip-button"
                                   matTooltip="Calculez l'impôt sur la plus value en fonction de votre situation, votre régime fiscal et l'année de revente"></i></li>
                            <li>Simulation en SCI à l’IS</li>
                            <li>20 analyses IA par mois
                                <i class="fa fa-question-circle ms-2" matTooltipClass="tooltip-button"
                                   [matTooltip]="aiCreditTooltip"></i>
                            </li>
                        </ul>

                    </div>
                </div>
                <div class="col-expert">
                <div class="pricing-light">
                    <h2 class="expert pb-3">Expert</h2>
                    <p class="desc">
                        Pour les investisseurs exigeants qui veulent être les premiers sur les meilleures affaires.
                    </p>
                    <b class="price">
                        <s class="promo"
                           *ngIf="promo == 'bf' || promo == 'rentree' || promo == 'partner' || promo == 'onboarding'">
                            ({{ userService.getPrice("expert", duration, user, promo, partner?.discount || 0)[1] | number:'1.0-2' }} €)
                        </s>
                        <img *ngIf="promo == 'bf'" src="assets/promo-bf-40.png"/>
                        <img *ngIf="promo == 'rentree'" src="assets/promo-rentree.png"/>
                        {{ userService.getPrice("expert", duration, user, promo, partner?.discount || 0)[0]|number:'1.0-2' }} €<span class="fs-5">/mois</span>
                        <small
                            *ngIf="(promo == 'bf' || promo == 'rentree') && (duration == 'month' || duration == 'quarter')">Pendant
                            3 mois</small>
                    </b>
                    <ng-container *ngIf="promo == 'partner_1month' || promo == 'parrain'">
                        Votre premier mois est offert
                    </ng-container>
                    <span class="diff_annuel" *ngIf="userService.getPrice('expert', duration, user, promo, partner?.discount || 0)[2] > 0">
                        ÉCONOMISEZ {{ userService.getPrice('expert', duration, user, promo, partner?.discount || 0)[2] }}€/AN EN PAYANT À L'ANNÉE
                    </span>

                    <a class="btn btn-outline-primary"
                       *ngIf="(user.plan == '' || user.plan == 'trial' || user.plan == 'trial_plus') && user.pro_plan == '' && user.subscription.plan == ''"
                       (click)="planSelect('expert')">
                        <mat-spinner diameter="25" [hidden]="!loading"></mat-spinner>
                        <span [hidden]="loading">Choisir ce forfait</span>
                    </a>
                    <ng-container *ngIf="user.plan != '' && user.plan != 'trial' && user.plan != 'trial_plus' && user.pro_plan == ''">
                        <a class="btn btn-outline-primary"
                           *ngIf="user.subscription.plan != 'expert'"
                           (click)="planChange('expert')">
                            Modifier mon forfait
                        </a>
                        <div class="text-center" *ngIf="user.subscription.plan == 'expert'">
                            <p class="btn btn-disabled">
                                <i class="fa fa-check"></i> Forfait actuel
                            </p>
                            <a (click)="planChange('expert')" class="cursor-pointer d-block mb-1">Modifier la fréquence</a>
                        </div>
                    </ng-container>
                    <h4>Fonctionnalités dans Essentiel, et :</h4>
                    <ul class="pricing-features">
                        <li>
                            Dossier bancaire en PDF
                            <i class="fa fa-question-circle  ms-2" matTooltipClass="tooltip-button"
                               matTooltip="Dossier bancaire : Mettez toutes les chances de votre côté pour obtenir votre crédit immobilier. Vous pourrez générer un rapport d’investissement professionnel en PDF détaillant chaque aspect de votre projet immobilier"></i>
                        </li>
                        <li>Accès aux locaux commerciaux</li>
                        <li>Personnalisation avancée
                            <i class="fa fa-question-circle ms-2"
                               matTooltipClass="tooltip-button"
                               matTooltip="Personnalisation des indicateurs dans les résultats de recherches et les favoris"></i></li>
                        <li>Simulation en LMP, SASU, EURL ...</li>
                        <li>100 analyses IA par mois
                            <i class="fa fa-question-circle ms-2" matTooltipClass="tooltip-button"
                               [matTooltip]="aiCreditTooltip"></i>
                        </li>
                        <li>Connecteur MCP pour votre IA
                            <i class="fa fa-question-circle ms-2" matTooltipClass="tooltip-button"
                               matTooltip="Utilisez LyBox directement depuis votre IA (Claude, ChatGPT…) : recherche d'annonces, rendement et cash-flow, données de marché, favoris, secteurs et alertes"></i>
                            <br/><br/>
                        </li>
                    </ul>
                </div>
            </div>
            </div>
            <a [routerLink]="['/app/user/plan-pro']" class="text-center pe-0 see_pro">
                <i class="fa fa-arrow-circle-o-right"></i><br/>
                Voir les offres pour professionnels
            </a>
        </div>
    </div>

    <section class="container-xl mt-4 pt-4 pt-md-5 pb-md-5 mb-0 pb-0 section-table">
        <table class="table table-striped table-hover pricing pricing-full">
            <thead class="princing-head">
            <tr>
                <ng-container *ngIf="!deviceService.isMobile()">
                    <th scope="col" class="col-6 text-center">
                        <!--                    <img (click)="switchDuration()" *ngIf="this.duration == 'month'"-->
                        <!--                         class="cursor-pointer btn-price mb-4" width="380" src="assets/price_month.png"-->
                        <!--                         alt="Tarif mensuel"/>-->
                        <!--                    <img (click)="switchDuration()" *ngIf="this.duration == 'year'"-->
                        <!--                         class="cursor-pointer btn-price mb-4" width="380" src="assets/price_year.png"-->
                        <!--                         alt="Tarif annuel"/>-->
                    </th>
                </ng-container>
                <th scope="col" class="col-2 text-center col-basique" [colSpan]="deviceService.isMobile() ? 2 : 1">
                    <h2 class="fs-4 mb-2 mt-1 basique">Basique</h2>
                    <b class="price">
                        <s class="promo d-block"
                           *ngIf="promo == 'bf' || promo == 'rentree' || promo == 'partner' || promo == 'onboarding'">
                            ({{ userService.getPrice("basique", duration, user, promo, partner?.discount || 0)[1] }} €)
                        </s>
                        {{ userService.getPrice("basique", duration, user, promo, partner?.discount || 0)[0]|number:'1.0-2' }} €<span class="fs-5">/mois</span>
                        <small
                            *ngIf="(promo == 'bf' || promo == 'rentree') && (duration == 'month' || duration == 'quarter')">Pendant
                            3 mois</small>
                    </b>

                    <a class="btn btn-sm btn-outline-primary btn"
                       *ngIf="(user.plan == '' || user.plan == 'trial' || user.plan == 'trial_plus') && user.pro_plan == '' && user.subscription.plan == ''"
                       (click)="planSelect('basique')">
                        <mat-spinner diameter="25" [hidden]="!loading"></mat-spinner>
                        <span [hidden]="loading">Souscrire</span>
                    </a>
                    <ng-container *ngIf="user.plan != '' && user.plan != 'trial' && user.plan != 'trial_plus' && user.pro_plan == ''">
                        <a class="btn btn-sm btn-outline-primary btn"
                           *ngIf="user.subscription.plan != 'basique'"
                           (click)="planChange('basique')">
                            Modifier mon forfait
                        </a>
                        <div class="text-center" *ngIf="user.subscription.plan == 'basique'">
                            <p class="btn btn-sm btn-disabled">
                                <i class="fa fa-check"></i> Forfait actuel
                            </p>
                            <a (click)="planChange('basique')" class="cursor-pointer d-block mb-1">Modifier la fréquence</a>
                        </div>
                    </ng-container>
                </th>
                <th scope="col" class="col-2 text-center col-essentiel" [colSpan]="deviceService.isMobile() ? 2 : 1">
                    <h2 class="fs-4 mb-2 mt-1 essentiel">Essentiel</h2>
                    <b class="price">
                        <s class="promo d-block"
                           *ngIf="promo == 'bf' || promo == 'rentree' || promo == 'partner' || promo == 'onboarding'">
                            ({{ userService.getPrice("essentiel", duration, user, promo, partner?.discount || 0)[1] | number:'1.0-2' }} €)
                        </s>
                        {{ userService.getPrice("essentiel", duration, user, promo, partner?.discount || 0)[0]|number:'1.0-2' }} €<span class="fs-5">/mois</span>
                        <small
                            *ngIf="(promo == 'bf' || promo == 'rentree') && (duration == 'month' || duration == 'quarter')">Pendant
                            3 mois</small>
                    </b>

                    <a class="btn btn-sm btn-primary"
                       *ngIf="(user.plan == '' || user.plan == 'trial' || user.plan == 'trial_plus') && user.pro_plan == '' && user.subscription.plan == ''"
                       (click)="planSelect('essentiel')">
                        <mat-spinner diameter="25" [hidden]="!loading"></mat-spinner>
                        <span [hidden]="loading">Souscrire</span>
                    </a>
                    <ng-container *ngIf="user.plan != '' && user.plan != 'trial' && user.plan != 'trial_plus' && user.pro_plan == ''">
                        <a *ngIf="user.subscription.plan != 'essentiel'"
                           class="btn btn-sm btn-outline-primary btn"
                           (click)="planChange('essentiel')">
                            Modifier mon forfait
                        </a>
                        <div class="text-center" *ngIf="user.subscription.plan == 'essentiel'">
                            <p class="btn btn-sm btn-disabled">
                                <i class="fa fa-check"></i> Forfait actuel
                            </p>
                            <a (click)="planChange('essentiel')" class="cursor-pointer d-block mb-1">Modifier la fréquence</a>
                        </div>
                    </ng-container>
                </th>
                <th scope="col" class="col-2 text-center col-expert" [colSpan]="deviceService.isMobile() ? 2 : 1">
                    <h2 class="fs-4 mb-2 mt-1 expert">Expert</h2>
                    <b class="price">
                        <s class="promo d-block"
                           *ngIf="promo == 'bf' || promo == 'rentree' || promo == 'partner' || promo == 'onboarding'">
                            ({{ userService.getPrice("expert", duration, user, promo, partner?.discount || 0)[1] | number:'1.0-2' }} €)
                        </s>
                        {{ userService.getPrice("expert", duration, user, promo, partner?.discount || 0)[0]|number:'1.0-2' }} €<span class="fs-5">/mois</span>
                        <small
                            *ngIf="(promo == 'bf' || promo == 'rentree') && (duration == 'month' || duration == 'quarter')">Pendant
                            3 mois</small>
                    </b>

                    <a class="btn btn-sm btn-outline-primary"
                       *ngIf="(user.plan == '' || user.plan == 'trial' || user.plan == 'trial_plus') && user.pro_plan == '' && user.subscription.plan == ''"
                       (click)="planSelect('expert')">
                        <mat-spinner diameter="25" [hidden]="!loading"></mat-spinner>
                        <span [hidden]="loading">Souscrire</span>
                    </a>

                    <ng-container *ngIf="user.plan != '' && user.plan != 'trial' && user.plan != 'trial_plus' && user.pro_plan == ''">
                        <a *ngIf="user.subscription.plan != 'expert'"
                           class="btn btn-sm btn-outline-primary btn"
                           (click)="planChange('expert')">
                            Modifier mon forfait
                        </a>
                        <div class="text-center" *ngIf="user.subscription.plan == 'expert'">
                            <p class="btn btn-sm btn-disabled">
                                <i class="fa fa-check"></i> Forfait actuel
                            </p>
                            <a (click)="planChange('expert')" class="cursor-pointer d-block mb-1">Modifier la fréquence</a>
                        </div>
                    </ng-container>
                </th>
            </tr>
            </thead>
            <tbody>
            <tr>
                <th colspan="2" scope="row" class="col-8 ps-4">
                    <h5>Extension LyBox - Analyse des annonces en direct
                        <i class="fa fa-info-circle ms-2"
                           matTooltipClass="tooltip-button"
                           matTooltip="Extension disponible sur Google Chrome et Mozilla Firefox. Compatible avec Leboncoin, SeLoger, Logic Immo et AvendreAlouer"></i>
                    </h5>
                </th>
                <td class="col-2 col-essentiel col-colspan"></td>
                <td class="col-2 col-colspan"></td>
            </tr>
            <tr>
                <th scope="row" class="col-6 ps-4">Analyse de la liste d'annonce
                    <i class="fa fa-info-circle ms-2"
                       matTooltipClass="tooltip-button"
                       matTooltip="Pour éviter de devoir ouvrir toutes les annonces pendant la recherche, les informations clés sont disponibles directement sur la liste d'annonces (prix au m², nombre d'habitants, taux d'étudiants ..."></i>
                </th>
                <td class="col-2 col-basique"><img class="lazyload" width="17"
                                                   src="assets/check.png" alt="Inclus">
                </td>
                <td class="col-2 col-essentiel"><img class="lazyload" width="17"
                                                     src="assets/check.png" alt="Inclus">
                </td>
                <td class="col-2 col-expert"><img class="lazyload" width="17"
                                                  src="assets/check.png" alt="Inclus">
                </td>
            </tr>
            <tr>
                <th scope="row" class="col-6 ps-4">Indicateurs de rendement simples
                    <i class="fa fa-info-circle ms-2"
                       matTooltipClass="tooltip-button"
                       matTooltip="Rendement brut, montant d'emprunt, mensualité de crédit"></i>
                </th>
                <td class="col-2 col-basique"><img class="lazyload" width="17"
                                                   src="assets/check.png" alt="Inclus">
                </td>
                <td class="col-2 col-essentiel"><img class="lazyload" width="17"
                                                     src="assets/check.png" alt="Inclus">
                </td>
                <td class="col-2 col-expert"><img class="lazyload" width="17"
                                                  src="assets/check.png" alt="Inclus">
                </td>
            </tr>
            <tr>
                <th scope="row" class="col-6 ps-4">Indicateurs de rendement avancés
                    <i class="fa fa-info-circle ms-2"
                       matTooltipClass="tooltip-button" matTooltip="Cash-Flow, rendement net"></i>
                </th>
                <td class="col-2 col-basique"><img class="lazyload" width="17"
                                                   src="assets/check.png" alt="Inclus">
                </td>
                <td class="col-2 col-essentiel"><img class="lazyload" width="17"
                                                     src="assets/check.png" alt="Inclus">
                </td>
                <td class="col-2 col-expert"><img class="lazyload" width="17"
                                                  src="assets/check.png" alt="Inclus">
                </td>
            </tr>
            <tr>
                <th scope="row" class="col-6 ps-4">Analyse de la ville
                    <i class="fa fa-info-circle ms-2"
                       matTooltipClass="tooltip-button"
                       matTooltip="Toutes les infos essentielles sur la ville : Nombre d'habitants, taux d'étudiants, taux de chômage, part de locataires, tension locative ..."></i>
                </th>
                <td class="col-2 col-basique"><img class="lazyload" width="17"
                                                   src="assets/check.png" alt="Inclus">
                </td>
                <td class="col-2 col-essentiel"><img class="lazyload" width="17"
                                                     src="assets/check.png" alt="Inclus">
                </td>
                <td class="col-2 col-expert"><img class="lazyload" width="17"
                                                  src="assets/check.png" alt="Inclus">
                </td>
            </tr>
            <tr>
                <th scope="row" class="col-6 ps-4">Estimation des prix et des loyers
                    <i class="fa fa-info-circle ms-2"
                       matTooltipClass="tooltip-button"
                       matTooltip="Retrouvez les prix de vente et les loyers par type de logement pour toutes les villes"></i>
                </th>
                <td class="col-2 col-basique"><img class="lazyload" width="17"
                                                   src="assets/check.png" alt="Inclus">
                </td>
                <td class="col-2 col-essentiel"><img class="lazyload" width="17"
                                                     src="assets/check.png" alt="Inclus">
                </td>
                <td class="col-2 col-expert"><img class="lazyload" width="17"
                                                  src="assets/check.png" alt="Inclus">
                </td>
            </tr>
            <tr>
                <th scope="row" class="col-6 ps-4">Historique du prix de l'annonce
                    <i class="fa fa-info-circle ms-2"
                       matTooltipClass="tooltip-button"
                       matTooltip="L'algorithme de LyBox trace les prix des annonces sur tous les sites immobiliers et est capable de détecter les annonces supprimées puis remises en ligne. L'outil ultime pour des négociations réussies !"></i>
                </th>
                <td class="col-2 col-basique"><img class="lazyload" width="17"
                                                   src="assets/check.png" alt="Inclus">
                </td>
                <td class="col-2 col-essentiel"><img class="lazyload" width="17"
                                                     src="assets/check.png" alt="Inclus">
                </td>
                <td class="col-2 col-expert"><img class="lazyload" width="17"
                                                  src="assets/check.png" alt="Inclus">
                </td>
            </tr>
            <tr>
                <th scope="row" class="col-6 ps-4">Analyses IA (annonce et DPE)
                    <i class="fa fa-info-circle ms-2"
                       matTooltipClass="tooltip-button"
                       [matTooltip]="aiCreditTooltip"></i>
                </th>
                <td class="col-2 col-basique"><b>5 / mois</b></td>
                <td class="col-2 col-essentiel"><b>20 / mois</b></td>
                <td class="col-2 col-expert"><b>100 / mois</b></td>
            </tr>
            <tr>
                <th colspan="2" scope="row" class="col-8 ps-4">
                    <h5>Moteur de recherche immobilier
                        <i class="fa fa-info-circle ms-2"
                           matTooltipClass="tooltip-button"
                           matTooltip="Moteur de recherche agrégeant les annonces de tout le web français"></i>
                    </h5>
                </th>
                <td class="col-2 col-essentiel col-colspan"></td>
                <td class="col-2 col-colspan"></td>
            </tr>
            <tr>
                <th scope="row" class="col-6 ps-4">Moteur de recherche sur +700 sites immobiliers
                    <i class="fa fa-info-circle ms-2"
                       matTooltipClass="tooltip-button"
                       matTooltip="Moteur de recherche multi-plateforme spécial investisseur : possibilité de filtrer sur la rentabilité, le prix au m², le nombre d'habitants, la localisation ..."></i>
                </th>
                <td class="col-2 col-basique"></td>
                <td class="col-2 col-essentiel"><img class="lazyload" width="17"
                                                     src="assets/check.png" alt="Inclus">
                </td>
                <td class="col-2 col-expert"><img class="lazyload" width="17"
                                                  src="assets/check.png" alt="Inclus">
                </td>
            </tr>
            <tr>
                <th scope="row" class="col-6 ps-4">Alertes mails sur les recherches
                    <i class="fa fa-info-circle ms-2"
                       matTooltipClass="tooltip-button"
                       matTooltip="Recevez en direct les nouvelles annonces parues sur l'un des 700 sites comptatibles directement dans votre boîte mail, sur toutes vos recherches"></i>
                </th>
                <td class="col-2 col-basique"></td>
                <td class="col-2 col-essentiel"><b>Alertes en direct</b></td>
                <td class="col-2 col-expert"><b>Alertes en direct</b></td>
            </tr>
            <tr>
                <th scope="row" class="col-6 ps-4">Indicateurs de rendement avancés sur vos résultats
                    <i class="fa fa-info-circle ms-2"
                       matTooltipClass="tooltip-button" matTooltip="Cash-Flow, rendement net"></i>
                </th>
                <td class="col-2 col-basique"></td>
                <td class="col-2 col-essentiel"><img class="lazyload" width="17"
                                                     src="assets/check.png" alt="Inclus">
                </td>
                <td class="col-2 col-expert"><img class="lazyload" width="17"
                                                  src="assets/check.png" alt="Inclus">
                </td>
            </tr>
            <tr>
                <th scope="row" class="col-6 ps-4">Outils de ciblage des villes où investir
                    <i class="fa fa-info-circle ms-2"
                       matTooltipClass="tooltip-button"
                       matTooltip="Recherche de ville avancée : possibilité de filtrer sur la rentabilité, le prix au m², le nombre d'habitants, le taux de chômage ..."></i>
                </th>
                <td class="col-2 col-basique"></td>
                <td class="col-2 col-essentiel"><img class="lazyload" width="17"
                                                     src="assets/check.png" alt="Inclus">
                </td>
                <td class="col-2 col-expert"><img class="lazyload" width="17"
                                                  src="assets/check.png" alt="Inclus">
                </td>
            </tr>
            <tr>
                <th scope="row" class="col-6 ps-4">Filtrage avancé des annonces
                    <i class="fa fa-info-circle ms-2"
                       matTooltipClass="tooltip-button"
                       matTooltip="Utilisation de plus de 20 filtres différents pour votre recherche"></i>
                </th>
                <td class="col-2 col-basique"></td>
                <td class="col-2 col-essentiel"><img class="lazyload" width="17"
                                                     src="assets/check.png" alt="Inclus">
                </td>
                <td class="col-2 col-expert"><img class="lazyload" width="17"
                                                  src="assets/check.png" alt="Inclus">
                </td>
            </tr>
            <tr>
                <th scope="row" class="col-6 ps-4">Recherche de commerces et fonds de commerces
                    <i class="fa fa-info-circle ms-2"
                       matTooltipClass="tooltip-button"
                       matTooltip="Ciblez uniquement les murs commerciaux et fonds de commerces"></i>
                </th>
                <td class="col-2 col-basique"></td>
                <td class="col-2 col-essentiel"></td>
                <td class="col-2 col-expert"><img class="lazyload" width="17"
                                                  src="assets/check.png" alt="Inclus">
                </td>
            </tr>
            <tr>
                <th scope="row" class="col-6 ps-4">Personnalisation des indicateurs
                    <i class="fa fa-info-circle ms-2"
                       matTooltipClass="tooltip-button"
                       matTooltip="Personnalisation des indicateurs dans les résultats de recherches et les favoris"></i>
                </th>
                <td class="col-2 col-basique"></td>
                <td class="col-2 col-essentiel"></td>
                <td class="col-2 col-expert"><img class="lazyload" width="17"
                                                  src="assets/check.png" alt="Inclus">
                </td>
            </tr>
            <tr>
                <th scope="row" class="col-6 ps-4">Connecteur <a href="https://www.lybox.fr/mcp" target="_blank">MCP pour votre IA</a>
                    <i class="fa fa-info-circle ms-2"
                       matTooltipClass="tooltip-button"
                       matTooltip="Utilisez LyBox directement depuis votre IA (Claude, ChatGPT…) : recherche d'annonces, rendement et cash-flow, données de marché, favoris, secteurs et alertes"></i>
                </th>
                <td class="col-2 col-basique"></td>
                <td class="col-2 col-essentiel"></td>
                <td class="col-2 col-expert"><img class="lazyload" width="17"
                                                  src="assets/check.png" alt="Inclus">
                </td>
            </tr>


            <tr>
                <th colspan="2" scope="row" class="col-8 ps-4"><h5>Espace utilisateur - Mes annonces immo
                    <i class="fa fa-info-circle ms-2"
                       matTooltipClass="tooltip-button"
                       matTooltip="Possibilité de créer des listes de favoris et d'y enregistrer vos annonces immobilières venant de sites différents dans un format optimisé pour les investisseurs"></i>
                </h5></th>
                <td class="col-2 col-essentiel col-colspan"></td>
                <td class="col-2 col-colspan"></td>
            </tr>
            <tr>
                <th scope="row" class="col-6 ps-4">Nombre de favoris maximum</th>
                <td class="col-2 col-basique"><b>
                    <ng-container *ngIf="user.p == '3'">10</ng-container>
                    <ng-container *ngIf="user.p != '3'">Illimité</ng-container>
                </b></td>
                <td class="col-2 col-essentiel"><b>
                    <ng-container *ngIf="user.p == '3'">50</ng-container>
                    <ng-container *ngIf="user.p != '3'">Illimité</ng-container>
                </b></td>
                <td class="col-2 col-expert"><b>Illimité</b></td>
            </tr>
            <tr>
                <th scope="row" class="col-6 ps-4">Personnalisation des colonnes
                    <i class="fa fa-info-circle ms-2"
                       matTooltipClass="tooltip-button"
                       matTooltip="Créez vous-même votre liste de favoris en affichant les informations qui vous intéressent suivant votre stratégie d'investissement"></i>
                </th>
                <td class="col-2 col-basique"></td>
                <td class="col-2 col-essentiel"></td>
                <td class="col-2 col-expert"><img class="lazyload" width="17"
                                                  src="assets/check.png" alt="Inclus">
                </td>
            </tr>
            <tr>
                <th scope="row" class="col-6 ps-4">Comparatif de projets
                    <i class="fa fa-info-circle ms-2"
                       matTooltipClass="tooltip-button"
                       matTooltip="Comparez plusieurs projets ou un même projet avec différents régimes d'imposition"></i>
                </th>
                <td class="col-2 col-basique"></td>
                <td class="col-2 col-essentiel"><img class="lazyload" width="17"
                                                     src="assets/check.png" alt="Inclus">
                </td>
                <td class="col-2 col-expert"><img class="lazyload" width="17"
                                                  src="assets/check.png" alt="Inclus">
                </td>
            </tr>
            <tr>
                <th scope="row" class="col-6 ps-4">Suivi de projet
                    <i class="fa fa-info-circle ms-2"
                       matTooltipClass="tooltip-button"
                       matTooltip="Checklist et prises de notes pour toutes les étapes de vos projets au même endroit, soyez sûr de ne rien oublier"></i>
                </th>
                <td class="col-2 col-basique"><img class="lazyload" width="17"
                                                   src="assets/check.png" alt="Inclus">
                </td>
                <td class="col-2 col-essentiel"><img class="lazyload" width="17"
                                                     src="assets/check.png" alt="Inclus">
                </td>
                <td class="col-2 col-expert"><img class="lazyload" width="17"
                                                  src="assets/check.png" alt="Inclus">
                </td>
            </tr>
            <tr>
                <th scope="row" class="col-6 ps-4">Historique du prix de l'annonce
                    <i class="fa fa-info-circle ms-2"
                       matTooltipClass="tooltip-button"
                       matTooltip="L'algorithme de LyBox trace les prix des annonces sur tous les sites immobiliers et est capable de détecter les annonces supprimées puis remises en ligne. L'outil ultime pour des négociations réussies !"></i>
                </th>
                <td class="col-2 col-basique">
                    <img class="lazyload" width="17" src="assets/check.png" alt="Inclus">
                </td>
                <td class="col-2 col-essentiel">
                    <img class="lazyload" width="17" src="assets/check.png" alt="Inclus">
                </td>
                <td class="col-2 col-expert">
                    <img class="lazyload" width="17" src="assets/check.png" alt="Inclus">
                </td>
            </tr>
            <tr>
                <th colspan="2" scope="row" class="col-8 ps-4"><h5>Espace utilisateur - Simulateur avancé</h5></th>
                <td class="col-2 col-essentiel col-colspan"></td>
                <td class="col-2 col-colspan"></td>
            </tr>
            <tr>
                <th scope="row" class="col-6 ps-4">Analyse poussée de la ville
                    <i class="fa fa-info-circle ms-2"
                       matTooltipClass="tooltip-button"
                       matTooltip="Analyse en détails de la ville : Évolution des prix, analyse des loyers, commerces, universités, nombre d'entreprises, typologie des logements, taille des ménages ..."></i>
                </th>
                <td class="col-2 col-basique"><img class="lazyload" width="17"
                                                   src="assets/check.png" alt="Inclus">
                </td>
                <td class="col-2 col-essentiel"><img class="lazyload" width="17"
                                                     src="assets/check.png" alt="Inclus">
                </td>
                <td class="col-2 col-expert"><img class="lazyload" width="17"
                                                  src="assets/check.png" alt="Inclus">
                </td>
            </tr>
            <tr>
                <th scope="row" class="col-6 ps-4">Analyse poussée du rendement
                    <i class="fa fa-info-circle ms-2"
                       matTooltipClass="tooltip-button"
                       matTooltip="Intégration de la totalité des frais liés à l'investissement : TF, gestion par agence, comptabilité, vacances locatives ..."></i>
                </th>
                <td class="col-2 col-basique"><img class="lazyload" width="17"
                                                   src="assets/check.png" alt="Inclus">
                </td>
                <td class="col-2 col-essentiel"><img class="lazyload" width="17"
                                                     src="assets/check.png" alt="Inclus">
                </td>
                <td class="col-2 col-expert"><img class="lazyload" width="17"
                                                  src="assets/check.png" alt="Inclus">
                </td>
            </tr>
            <tr>
                <th scope="row" class="col-6 ps-4">Tableur d'estimation travaux
                    <i class="fa fa-info-circle ms-2"
                       matTooltipClass="tooltip-button"
                       matTooltip="Décrivez vos travaux en détails pour connaitre le budget nécessaire pour votre chantier"></i>
                </th>
                <td class="col-2 col-basique"></td>
                <td class="col-2 col-essentiel"><img class="lazyload" width="17"
                                                     src="assets/check.png" alt="Inclus">
                </td>
                <td class="col-2 col-expert"><img class="lazyload" width="17"
                                                  src="assets/check.png" alt="Inclus">
                </td>
            </tr>
            <tr>
                <th scope="row" class="col-6 ps-4">Imposition l'IR, LMNP
                    <i class="fa fa-info-circle ms-2"
                       matTooltipClass="tooltip-button"
                       matTooltip="Foncier forfait, foncier réel, LMNP forfait, LMNP réel"></i>
                </th>
                <td class="col-2 col-basique"><img class="lazyload" width="17"
                                                   src="assets/check.png" alt="Inclus">
                </td>
                <td class="col-2 col-essentiel"><img class="lazyload" width="17"
                                                     src="assets/check.png" alt="Inclus">
                </td>
                <td class="col-2 col-expert"><img class="lazyload" width="17"
                                                  src="assets/check.png" alt="Inclus">
                </td>
            </tr>
            <tr>
                <th scope="row" class="col-6 ps-4">Imposition SCI à l'IS</th>
                <td class="col-2 col-basique"></td>
                <td class="col-2 col-essentiel"><img class="lazyload" width="17"
                                                     src="assets/check.png" alt="Inclus">
                </td>
                <td class="col-2 col-expert"><img class="lazyload" width="17"
                                                  src="assets/check.png" alt="Inclus">
                </td>
            </tr>
            <tr>
                <th scope="row" class="col-6 ps-4">Imposition Pinel et Denormandie</th>
                <td class="col-2 col-basique"></td>
                <td class="col-2 col-essentiel"><img class="lazyload" width="17"
                                                     src="assets/check.png" alt="Inclus">
                </td>
                <td class="col-2 col-expert"><img class="lazyload" width="17"
                                                  src="assets/check.png" alt="Inclus">
                </td>
            </tr>
            <tr>
                <th scope="row" class="col-6 ps-4">Imposition LMP</th>
                <td class="col-2 col-basique"></td>
                <td class="col-2 col-essentiel"></td>
                <td class="col-2 col-expert"><img class="lazyload" width="17"
                                                  src="assets/check.png" alt="Inclus">
                </td>
            </tr>
            <tr>
                <th scope="row" class="col-6 ps-4">Comparatif des régimes fiscaux
                    <i class="fa fa-info-circle ms-2"
                       matTooltipClass="tooltip-button"
                       matTooltip="Choisissez le meilleur régime fiscal pour chaque projet à l'aide du TRI, VAN, Enrichissement, Cash-Flow ..."></i>
                </th>
                <td class="col-2 col-basique"><img class="lazyload" width="17"
                                                   src="assets/check.png" alt="Inclus">
                </td>
                <td class="col-2 col-essentiel"><img class="lazyload" width="17"
                                                     src="assets/check.png" alt="Inclus">
                </td>
                <td class="col-2 col-expert"><img class="lazyload" width="17"
                                                  src="assets/check.png" alt="Inclus">
                </td>
            </tr>
            <tr>
                <th scope="row" class="col-6 ps-4">Imposition à la revente
                    <i class="fa fa-info-circle ms-2"
                       matTooltipClass="tooltip-button"
                       matTooltip="Calculez l'impôt sur la plus value en fonction de votre situation, votre régime fiscal et l'année de revente"></i>
                </th>
                <td class="col-2 col-basique"></td>
                <td class="col-2 col-essentiel"><img class="lazyload" width="17"
                                                     src="assets/check.png" alt="Inclus">
                </td>
                <td class="col-2 col-expert"><img class="lazyload" width="17"
                                                  src="assets/check.png" alt="Inclus">
                </td>
            </tr>
            <tr>
                <th scope="row" class="col-6 ps-4">Calculs en temps réels
                    <i class="fa fa-info-circle ms-2"
                       matTooltipClass="tooltip-button"
                       matTooltip="Tous les indicateurs sont actualisés en temps réels, votre temps est précieux"></i>
                </th>
                <td class="col-2 col-basique"><img class="lazyload" width="17"
                                                   src="assets/check.png" alt="Inclus">
                </td>
                <td class="col-2 col-essentiel"><img class="lazyload" width="17"
                                                     src="assets/check.png" alt="Inclus">
                </td>
                <td class="col-2 col-expert"><img class="lazyload" width="17"
                                                  src="assets/check.png" alt="Inclus">
                </td>
            </tr>
            <tr>
                <th scope="row" class="col-6 ps-4">Différé de remboursement et durée des travaux
                    <i class="fa fa-info-circle ms-2"
                       matTooltipClass="tooltip-button"
                       matTooltip="Prise en compte du différé de crédit, de la durée des travaux et du montant des loyers avant travaux (pour les immeubles par exemple) dans le calcul de l'imposition"></i>
                </th>
                <td class="col-2 col-basique"></td>
                <td class="col-2 col-essentiel"></td>
                <td class="col-2 col-expert"><img class="lazyload" width="17"
                                                  src="assets/check.png" alt="Inclus">
                </td>
            </tr>
            <tr>
                <th scope="row" class="col-6 ps-4">Récapitulatif du projet
                    <i class="fa fa-info-circle ms-2"
                       matTooltipClass="tooltip-button"
                       matTooltip="Un récapitulatif simple et précis des chiffres du projet. Idéal pour présenter votre dossier à une banque ou un courtier"></i>
                </th>
                <td class="col-2 col-basique"><img class="lazyload" width="17"
                                                   src="assets/check.png" alt="Inclus">
                </td>
                <td class="col-2 col-essentiel"><img class="lazyload" width="17"
                                                     src="assets/check.png" alt="Inclus">
                </td>
                <td class="col-2 col-expert"><img class="lazyload" width="17"
                                                  src="assets/check.png" alt="Inclus">
                </td>
            </tr>
            <tr>
                <th scope="row" class="col-6 ps-4">Dashboard personnalisé
                    <i class="fa fa-info-circle ms-2"
                       matTooltipClass="tooltip-button"
                       matTooltip="Construisez vous-mêmes votre dashboard, optimisé pour votre style d'investissement"></i>
                </th>
                <td class="col-2 col-basique"></td>
                <td class="col-2 col-essentiel"></td>
                <td class="col-2 col-expert"><img class="lazyload" width="17"
                                                  src="assets/check.png" alt="Inclus">
                </td>
            </tr>
            <tr>
                <th scope="row" class="col-6 ps-4">Export PDF
                    <i class="fa fa-info-circle ms-2"
                       matTooltipClass="tooltip-button" matTooltip="Exportez votre analyse en format PDF"></i>
                </th>
                <td class="col-2 col-basique"></td>
                <td class="col-2 col-essentiel"></td>
                <td class="col-2 col-expert"><img class="lazyload" width="17"
                                                  src="assets/check.png" alt="Inclus">
                </td>
            </tr>
            </tbody>
        </table>
    </section>

    <div class="row pricing d-md-none pricing-menu" [class.has-promo]="promo != ''">
        <div class="col-4 text-center switch-pricing" (click)="switchPricing($event.currentTarget)"
             data-target="col-basique">
            <h2 class="text-center fs-6 basique">Basique</h2>
            <b class="price">
                <s class="promo"
                   *ngIf="promo == 'bf' || promo == 'rentree' || promo == 'partner' || promo == 'onboarding'">
                    ({{ userService.getPrice("basique", duration, user, promo, partner?.discount || 0)[1] | number:'1.0-2' | number:'1.0-2' }} €)
                </s>
                <img *ngIf="promo == 'bf'" src="assets/promo-bf-40.png"/>
                <img *ngIf="promo == 'rentree'" src="assets/promo-rentree.png"/>
                {{ userService.getPrice("basique", duration, user, promo, partner?.discount || 0)[0]|number:'1.0-2' }} €<span class="fs-5">/mois</span>
            </b>
        </div>
        <div class="col-4 text-center active switch-pricing" (click)="switchPricing($event.currentTarget)"
             data-target="col-essentiel">
            <h2 class="text-center fs-6 essentiel">Essentiel</h2>
            <b class="price">
                <s class="promo"
                   *ngIf="promo == 'bf' || promo == 'rentree' || promo == 'partner' || promo == 'onboarding'">
                    ({{ userService.getPrice("essentiel", duration, user, promo, partner?.discount || 0)[1] | number:'1.0-2' }} €)
                </s>
                <img *ngIf="promo == 'bf'" src="assets/promo-bf-40.png"/>
                <img *ngIf="promo == 'rentree'" src="assets/promo-rentree.png"/>
                {{ userService.getPrice("essentiel", duration, user, promo, partner?.discount || 0)[0]|number:'1.0-2' }} €<span class="fs-5">/mois</span>
            </b>
        </div>
        <div class="col-4 text-center switch-pricing" (click)="switchPricing($event.currentTarget)"
             data-target="col-expert">
            <h2 class="text-center fs-6 expert">Expert</h2>
            <b class="price">
                <s class="promo"
                   *ngIf="promo == 'bf' || promo == 'rentree' || promo == 'partner' || promo == 'onboarding'">
                    ({{ userService.getPrice("expert", duration, user, promo, partner?.discount || 0)[1] | number:'1.0-2' }} €)
                </s>
                <img *ngIf="promo == 'bf'" src="assets/promo-bf-40.png"/>
                <img *ngIf="promo == 'rentree'" src="assets/promo-rentree.png"/>
                {{ userService.getPrice("expert", duration, user, promo, partner?.discount || 0)[0]|number:'1.0-2' }} €<span class="fs-5">/mois</span>
            </b>
        </div>
    </div>
</div>
